/** A path inside this site, safe to send someone back to after signing in
 *  (`?next=`). Another site never is: `//evil.com` and `/\evil.com` are
 *  refused, as is anything not starting with one slash. */
export const safeNext = (next: string | null | undefined): string | null =>
  next && next.startsWith('/') && !next.startsWith('//') && !next.startsWith('/\\') ? next : null;
